/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
// 2021-04-012 relative-ratings-app RequestRating.js and relative-rankings-chrome-extension functions.js share this same code => move to shared component

// regex to check if the entered str is github url
const checkValidGitHubUrl = (str) => {
  const pattern = new RegExp(
    "^(http://www.|https://www.|http://|https://)?" + // eslint-disable-line
      "github.com/.+"
  ); // domain name
  return pattern.test(str);
};

// regex to check if the entered str is stackoverflow url
const checkValidStackOverflowUrl = (str) => {
  const pattern = new RegExp(
    "^(http://www.|https://www.|http://|https://)?" + // eslint-disable-line
      "stackoverflow.com/.+"
  ); // domain name
  return pattern.test(str);
};

// extract whatever is after https://github.com/ or github.com/
const extractUsername = (url) => {
  const split = url.toString().split("/");
  if (split[3]) {
    return split[3];
  }

  return split[1];
};

const extractUserId = (url) => {
  let userIDValue = "";
  const urlseg = url.toString().split("/");
  for (let i = 0; i < urlseg.length; i++) {
    if (!isNaN(urlseg[i])) {
      userIDValue = urlseg[i];
    }
  }

  return userIDValue;
};

const checkValidUrl = (str) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return pattern.test(str);
};


const fixedEncodeURIComponent = (str) => {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16);
  });
};

const crunchOwnRating = (githubToken) => {
  const data = {
    token: githubToken,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/request-own-rating";
  return axios.post(requestUrl, data, config);
};

const crunchOtherRating = (githubId, uuidCredit) => {
  const data = {
    githubId: githubId,
    uuidCredit: uuidCredit
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/request-rating";

  return axios.post(requestUrl, data, config);
};

const crunchOtherDetailedAnalysis = (githubId, uuid_credit, quickAnalysisDone) => {
  const data = {
    githubId: githubId,
    userId: uuid_credit,
    quickAnalysisDone: quickAnalysisDone
  }

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  }

  const requestUrl = process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/detailed"

  return axios.post(requestUrl, data, config)
}

const crunchOwnRatingStackOverflow = (stackoverflowToken) => {
  const data = {
    token: stackoverflowToken,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
    "/api/stackoverflow/request-own-rating";
  return axios.post(requestUrl, data, config);
};

const crunchOtherRatingStackOverflow = (stackoverflowId) => {
  const data = {
    stackoverflowId: stackoverflowId,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
    "/api/stackoverflow/request-rating";

  return axios.post(requestUrl, data, config);
};

//Retrieve GitHub username from login
const getGitHubUsername = (githubToken) => {
  const data = {
    token: githubToken,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
    "/api/get-github-username";
  return axios.post(requestUrl, data, config);
};

//Retrieve StackOverflow username from login
const getStackOverflowUsername = (stackoverflowToken) => {
  const data = {
    token: stackoverflowToken,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
    "/api/stackoverflow/get-so-username";
  return axios.post(requestUrl, data, config);
};

//Retrieve StackOverflow username from userID
const getStackOverflowUsername_userid = (stackoverflowId) => {
  const data = {
    stackoverflowId: stackoverflowId,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +
    "/api/stackoverflow/get-so-username";
  return axios.post(requestUrl, data, config);
};

const generate_profile = (github_token, stackoverflow_token) => {
  const data = {
    github_token,
    stackoverflow_token,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestUrl =
    process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE + "/api/generate-profile";
  return axios.post(requestUrl, data, config);
};

const checkRating = function(expectedLevel, result){
  if( (expectedLevel=== "intern" && parseFloat(result) < 80 ) || 
      (expectedLevel === "junior" && parseFloat(result) < 60) ||
      (expectedLevel === "mid-level" && parseFloat(result) < 40) || 
      (expectedLevel === "senior" && parseFloat(result) < 20) )
        return true
  else 
    return false
}

export {generate_profile, getStackOverflowUsername, getStackOverflowUsername_userid, getGitHubUsername, crunchOtherRating, crunchOtherDetailedAnalysis,
    crunchOtherRatingStackOverflow,crunchOwnRating,crunchOwnRatingStackOverflow, checkValidUrl, checkValidStackOverflowUrl, checkValidGitHubUrl, 
    extractUserId, extractUsername, fixedEncodeURIComponent, checkRating};
